import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../core/services/api.service';

@Component({
  selector: 'app-roleinsights',
  standalone: true,
  imports: [CommonModule, FormsModule,  ],
  templateUrl: './roleinsights.html',
  styleUrls: ['./roleinsights.scss']
})
export class Roleinsights implements OnInit {
  roles: any[] = [];
  selectedRole: any = null;
  questions: any[] = [];
  allQuestions: any[] = [];
  loading = false;

  isSaving: Record<number, boolean> = {};
  groupCode ;

  constructor(
    private api: ApiService,
   ) {
    const storedUser = localStorage.getItem('userInfo');
console.log(storedUser);
  if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      this.groupCode = parsedUser?.group;
  }

  }
  ngOnInit(): void {
    this.getRoles();
    this.getAllQuestions();
  }

getRoles() {
  this.api.getMethod1<any[]>(`roles/groupcode/${this.groupCode}`).subscribe({
    next: (res) => {
      this.roles = res;
      const superAdmin = this.roles.find(r => r.Role_Name === 'Super Admin');
      if (superAdmin) {
        this.selectedRole = superAdmin;
        this.onRoleChange(superAdmin);
      }
    },
    error: (err) => console.error('Error fetching roles:', err)
  });
}

getAllQuestions() {
  this.api.getMethod1<any[]>(`questions`).subscribe({
    next: (res) => {
      this.allQuestions = res.map(q => ({ ...q, Status: 'Inactive' }));
      if (this.selectedRole) this.onRoleChange(this.selectedRole);
      else this.questions = [...this.allQuestions];
    },
    error: (err) => console.error('Error fetching all questions:', err)
  });
}

onRoleChange(role: any) {
  this.loading = true;
  this.api.getMethod1<any[]>(`questions/role/${role.Role_Uniqid}`).subscribe({
    next: (res) => {
      const activeIds = new Set(res.map(rq => rq.Id));
      this.questions = this.allQuestions.map(q => ({
        ...q,
        Status: activeIds.has(q.Id) ? 'Active' : 'Inactive'
      }));
    },
    error: (err) => console.error(`Error fetching questions for role ${role.Role_Uniqid}:`, err),
    complete: () =>    this.loading = false
  });
}

  toggleQuestionStatus(q: any, ev?: Event) {
    if (!this.selectedRole?.Role_Uniqid) return;

    const roleId = Number(this.selectedRole.Role_Uniqid);
    const questionId = Number(q.Id);

    this.isSaving[questionId] = true;
     this.loading = true;

    if (q.Status === 'Active') {
      // DELETE → Inactivate
      this.api.deletemethod(`questions/${questionId}/roles/${roleId}`, {}).subscribe({
        next: () => { q.Status = 'Inactive'; },
        error: (err) => {
          if (ev) (ev.target as HTMLInputElement).checked = true;
          console.error('Error removing role from question:', err);
        },
        complete: () => {
          this.isSaving[questionId] = false;
           this.loading = false;
        }
      });
    } else {
      // POST → Activate
      this.api.postmethod(`questions/${questionId}/roles`, { roleId }).subscribe({
        next: () => { q.Status = 'Active'; },
        error: (err) => {
          if (ev) (ev.target as HTMLInputElement).checked = false;
          console.error('Error adding role to question:', err);
        },
        complete: () => {
          this.isSaving[questionId] = false;
           this.loading = false;
        }
      });
    }
  }
}
